import React from 'react';

function PromoBox({ promo, selectedItems, onShowDetails, bgColor, borderColor, showFilteredOnly, viewFullCalendar, filteredPromoKeys }) {
    // Format dates for display
    const formatDate = (dateStr) => {
        const date = new Date(dateStr + 'T00:00:00');
        return date.toLocaleDateString('en-US', {
            month: 'numeric',
            day: 'numeric'
        });
    };

    // Get the items to display based on filter settings
    const getDisplayItems = () => {
        if (showFilteredOnly && selectedItems && selectedItems.length > 0) {
            return promo.items.filter(item => selectedItems.includes(item.groupedName || item.item));
        }
        return promo.items;
    };

    const displayItems = getDisplayItems();

    // Calculate discount range from display items (for Product Specific Promo and Sitewide Sale promos)
    const getDiscountRange = () => {
        // Only show discount range for these promo types
        const showDiscountTypes = ['Product Specific Promo', 'Sitewide Sale'];
        if (!showDiscountTypes.includes(promo.promoType)) {
            return null;
        }

        const discounts = displayItems
            .map(i => i.discount)
            .filter(d => d != null && d > 0);

        if (discounts.length === 0) return null;

        const uniqueDiscounts = [...new Set(discounts)].sort((a, b) => a - b);

        if (uniqueDiscounts.length === 1) {
            return `${(uniqueDiscounts[0] * 100).toFixed(0)}% off`;
        } else {
            return `${(uniqueDiscounts[0] * 100).toFixed(0)}-${(uniqueDiscounts[uniqueDiscounts.length - 1] * 100).toFixed(0)}% off`;
        }
    };

    const isAllWebstore = promo.allWebstore;
    const discountRange = getDiscountRange();

    // Determine if this promo should be dimmed (View Full Calendar mode)
    const isDimmed = viewFullCalendar && filteredPromoKeys &&
        !filteredPromoKeys.has(`${promo.name}|${promo.startDate}|${promo.endDate}`);

    return (
        <div
            className={`promo-box${isDimmed ? ' dimmed' : ''}`}
            style={{
                backgroundColor: bgColor,
                borderColor: borderColor
            }}
        >
            <div className="promo-name" style={{ color: '#212121' }}>
                {promo.name}
            </div>
            <div className="promo-dates" style={{ color: '#424242' }}>
                {formatDate(promo.startDate)} - {formatDate(promo.endDate)}
            </div>

            {/* Show item count (or All Webstore) and discount range on same line */}
            <div className="promo-info-row">
                {isAllWebstore ? (
                    <span className="promo-info no-click">
                        All Webstore Products
                    </span>
                ) : (
                    <>
                        <span
                            className="promo-info"
                            onClick={(e) => {
                                e.stopPropagation();
                                onShowDetails(promo);
                            }}
                            title="Click to see items and discounts"
                        >
                            {displayItems.length} item{displayItems.length !== 1 ? 's' : ''}
                        </span>
                        {discountRange && (
                            <span className="promo-discount">at {discountRange}</span>
                        )}
                    </>
                )}
            </div>

            {promo.details && (
                <div className="promo-details">
                    {promo.details}
                </div>
            )}
        </div>
    );
}

export default PromoBox;
